import { getDoc, setDoc, query, doc } from "firebase/firestore";
import { database } from '../firebase-config';
export const COLLECTION = "settings";

export class Settings {
    document_reference = ""
    user = ""
    hourly_labor_rate = 0
    low_profit_index = 0
    profit_index = 0
    title_text = ""
    last_update = ""
    history = new Array()
}

export const getSettings = async (documentRef) => {
    try {
        const existingDocRef = doc(database, COLLECTION, documentRef);
        const existingDoc = await getDoc(existingDocRef);
        if (!existingDoc.exists()) {
          console.log("getSettings(): "+ documentRef + "not found!");
          return '';
        } else {
          return existingDoc;
        }
    } catch (e) {
        console.log("getSettings(): Error getting " + COLLECTION + " ref:" + documentRef);
    }
}

export function documentToSettings(existingDoc) {
    let existingSettings = new Settings();
    existingSettings.document_reference = existingDoc.id;
    existingSettings.user = existingDoc.data().user;
    existingSettings.hourly_labor_rate = existingDoc.data().hourly_labor_rate;
    existingSettings.low_profit_index = existingDoc.data().low_profit_index;
    existingSettings.profit_index = existingDoc.data().profit_index;
    existingSettings.title_text = existingDoc.data().title_text;
    existingSettings.last_update = existingDoc.data().last_update;
    existingSettings.history = existingDoc.data().history;

    return existingSettings;
}
